// profile-navbar/SnackNavBarProfile.jsx
import React from "react";
import logo from "../../../ingredients/multimedia/images/logo.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SnackProfileNavBar.css";
import { Navbar, Nav } from "react-bootstrap";
import { useUser } from "../../../utensils/UserContext";
import { useStatusBoard } from "../../../utensils/StatusBoardContext"; // 👈 Importar

const SnackNavBarProfile = () => {
  const { logoutUser } = useUser();
  const { clearSelection } = useStatusBoard(); // 👈 Usar función limpia selección

  const handleLogout = () => {
    clearSelection(); // ✅ Limpia ejercicio, día e ingesta
    logoutUser(); // ✅ Cierra sesión
  };

  return (
    <Navbar expand="lg" className="w-100 custom-navbar">
      <Navbar.Brand className="d-flex align-items-center">
        <img src={logo} alt="Logo" className="logo mr-2" />
        <span className="brand-name">Mi tablero</span>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />

      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="basic-nav-dropdown">
          <Nav.Link onClick={handleLogout}>Cerrar sesión</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default SnackNavBarProfile;
